<template>
  <div class="w-full">
    <div id="riskHiddenDnagerLineChart" class="w-full h-200px" v-loading="loading"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { RiskStatisticsApi } from '@wiz-api/double-prevention-management'

const riskStatisticsApi = new RiskStatisticsApi()

export default {
  name: 'line-chart',
  props: {
    type: {
      type: String,
      default: 'department',
    },
  },
  data() {
    return {
      loading: false,
      departmentValues: [],
      myChart: null,
      chartLoading: false,
      option: {
        title: {
          // text: 'World Population',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          top: '2%',
          left: '1%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
        },
        axisLine: {
          show: true,
        },

        xAxis: {
          type: 'value',
          min: 0,
          max: 100, // 指定一个x轴的最大值，才会再滚动到第二屏的时候柱形长度不变长
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(36, 173, 254, 0.2)',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#a0adb4',
            },
          },
        },
        dataZoom: [],
        yAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          minInterval: 1,
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: 'white',
            },
            formatter(params) {
              let val = ''
              if (params.length > 10) {
                val = `${params.substr(0, 10)}...`
                return val
              }
              return params
            },
          },
          // min: 1, // 设置 y 轴显示的最小值
          // max: 50, // 设置 y 轴显示的最大值
          data: [],
        },

        series: [
          {
            // name: '2011',
            type: 'bar',
            data: [],
            boundaryGap: false, // 关闭坐标轴两端的空白
            // min: , // 设置 y 轴显示的最小值
            // max: 11, // 设置 y 轴显示的最大值
            barWidth: 20, // 柱条的宽度,不设时自适应
            itemStyle: {
              color: 'rgba(21,118,136,0.8)',
            },
            label: {
              show: true,
              position: 'right',
              color: 'white',
              fontSize: 14,
              fontWeight: 'bold',
            },
          },
        ],
      },
    }
  },
  watch: {
    type: {
      handler(data) {
        if (data === 'department') {
          this.getDepartmentValues()
        } else {
          this.getAreaValues()
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 绘制echarts
    drawCharts() {
      this.myChart = echarts.init(document.getElementById('riskHiddenDnagerLineChart'))
      this.option.yAxis.data = _.map(this.departmentValues, (item) => {
        return item.name
      })
      this.option.series[0].data = _.map(this.departmentValues, (item) => {
        return item.total
      })
      const dataZoom = [
        {
          type: 'inside', // 支持内部鼠标滚动平移
          start: 25,
          end: 100,
          yAxisIndex: 0,
          zoomOnMouseWheel: false, // 关闭滚轮缩放
          moveOnMouseWheel: true, // 开启滚轮平移
          moveOnMouseMove: false, // 鼠标移动能触发数据窗口平移
        },
      ]
      // 是否开启滚动缩放
      if (this.departmentValues && this.departmentValues.length > 7) {
        this.option.dataZoom = dataZoom
      }
      this.myChart.setOption(this.option)

      window.addEventListener('resize', () => {
        this.myChart.resize()
      })
    },
    // 获取区域统计数据
    async getDepartmentValues() {
      this.loading = true
      const [err, res] = await riskStatisticsApi.riskStatisticsControlResponsibleDepartment()
      if (!err) {
        const departmentValues = _.forEach(res, (item) => {
          item.name = item.organizationUnitText
          item.total =
            Number(item.generalRiskCount) +
            Number(item.greaterRiskCount) +
            Number(item.significantRiskCount) +
            Number(item.lowRiskCount)
        })
        this.departmentValues = _.sortBy(departmentValues, (o) => {
          return o.total
        })
        this.drawCharts()
        this.loading = false
      }
    },
    // 获取区域统计数据
    async getAreaValues() {
      this.loading = true
      const [err, res] = await riskStatisticsApi.riskStatisticsArea()
      if (!err) {
        const departmentValues = _.forEach(res, (item) => {
          item.name = item.areaText
          item.total =
            Number(item.generalRiskCount) +
            Number(item.greaterRiskCount) +
            Number(item.significantRiskCount) +
            Number(item.lowRiskCount)
        })
        this.departmentValues = _.sortBy(departmentValues, (o) => {
          return o.total
        })
        this.drawCharts()
        this.loading = false
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.myChart.resize()
    })
  },
}
</script>

<style lang="scss" scoped></style>
